<template>
    <div>
        <b-row>
            <b-col cols="6">
                <b-form-group :label="$t('type')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.type) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('pathname')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.path) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('faculty_code')">
                    <b-input-group>
                        <div class="label-as-input">{{ Array.isArray(form.faculty_code) ? form.faculty_code.join(', ') : isNotNullValue(form.faculty_code) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('department_code')">
                    <b-input-group>
                        <div class="label-as-input">{{ Array.isArray(form.department_code) ? form.department_code.join(', ') : isNotNullValue(form.department_code) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group :label="$t('program_code')">
                    <b-input-group>
                        <div class="label-as-input">{{ Array.isArray(form.program_code) ? form.program_code.join(', ') : isNotNullValue(form.program_code) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('roles')">
                    <b-input-group>
                        <div class="label-as-input">{{ Array.isArray(form.roles) ? form.roles.join(', ') : isNotNullValue(form.roles) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('filter')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.filter) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('message')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.message) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('message_en')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.message_en) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input">
                            <span v-if="form.status === true">{{ $t('active') }}</span>
                            <span v-else-if="form.status === false">{{ $t('passive') }}</span>
                            <span v-else>{{ isNotNullValue(form.status) }}</span>
                        </div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import PageMessagesService from '@/services/PageMessagesService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    type: null,
                    path: null,
                    faculty_code: null,
                    department_code: null,
                    program_code: null,
                    roles: null,
                    filter: null,
                    message: null,
                    message_en: null,
                    status: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                PageMessagesService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
